import { Component, Input, OnChanges, OnInit, SimpleChanges, AfterViewInit, Renderer2 } from '@angular/core';
import {  OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { CatalogService } from '../../../services/catalog.service';
import { DentalProblemModel } from '../../../models/dental-problem.model';
import { PetNoteModel,NoteModel } from '../../../models/pet-note.model';
import { MONITOR_ANES, MONITOR_BREATH, MONITOR_FLUIDS, HYDRATION, LUNG_SOUNDS, HEARTH_SOUNDS, PULSE_QUALITY, MM_COLOR, CRT, SUTURE, SUTURE_OTHER, TOOTH } from '../../../../environments/environment';
import Swal from 'sweetalert2';
import 'jquery-imagemapster';
import { CodesFileModel } from '../../../models/codes-file.model';
import { ToothProblemModel } from '../../../models/tooth-problem.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'ngx-work-profile-dental',
  templateUrl: './profile-dental.component.html',
  styleUrls: ['./profile-dental.component.scss']
})
export class ProfileDentalComponent implements OnInit {

  first_index: number = 0;
  last_index: number = 0;
  private _pet_no: number;
  MONITOR_ANES = MONITOR_ANES;
  MONITOR_FLUIDS = MONITOR_FLUIDS;
  MONITOR_BREATH = MONITOR_BREATH;
  HYDRATION = HYDRATION;
  LUNG_SOUNDS = LUNG_SOUNDS;
  HEARTH_SOUNDS = HEARTH_SOUNDS;
  PULSE_QUALITY = PULSE_QUALITY;
  MM_COLOR = MM_COLOR;
  CRT = CRT;
  SUTURE = SUTURE;
  SUTURE_OTHER = SUTURE_OTHER;
  TOOTH = TOOTH;
  kitten_dental: boolean = false;
  puppy_dental: boolean = false;
  dog_dental: boolean = true;
  cat_dental: boolean = false;
  selectedTeethType = ''

  selectedTooth: number = 0;
  tooth_option = []

  dogteethlist = [101, 102, 103, 104, 105, 106, 107, 108, 109, 110,
                  201, 202, 203, 204, 205, 206, 207, 208, 209, 210,
                  301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311,
                  401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411]

  puppyteethlist = [
                  501, 502, 503, 504, 506, 507, 508,
                  601, 602, 603, 604, 606, 607, 608,
                  801, 802, 803, 804, 806, 807, 808,
                  701, 702, 703, 704, 706, 707, 708]    
                  
  kittennteethlist = [
                  501, 502, 503, 504, 506, 507, 508,
                  601, 602, 603, 604, 606, 607, 608,
                  701, 702, 703, 704, 706, 707, 708,
                  801, 802, 803, 804, 806, 807, 808]

  catteethlist = [
                  101, 102, 103, 104, 106, 107, 108, 109,
                  201, 202, 203, 204, 206, 207, 208, 209,
                  301, 302, 303, 304, 307, 308, 309,
                  401, 402, 403, 404, 407, 408, 409]


  //SVG RELATED
   @ViewChild('svgContainer') svgContainerRef: ElementRef;
  svgUrl: SafeResourceUrl;
  selectedToothId: number | null = null;
  private readonly destroyed = new Subject<void>();

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.petService.getVitalsByPetId(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    public catalogService: CatalogService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private el: ElementRef, 
    private renderer: Renderer2
  ) {
    
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
        this.changePetImage()
      });

      this.svgUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/dog-teeth.svg');  
 
    $(document).ready(function () {
      $('#kittenmouth_img').mapster({
        singleSelect: true,
        fillColor: 'FF9933',
        fillOpacity: 0.5,
        stroke: true,
        strokeColor: 'FF5733',
        strokeWidth: 2
      });

      $('#puppymouth_img').mapster({
        singleSelect: true,
        fillColor: 'FF9933',
        fillOpacity: 0.5,
        stroke: true,
        strokeColor: 'FF5733',
        strokeWidth: 2
      });

      $('#dogmouth_img').mapster({
        singleSelect: true,
        fillColor: '6CB4EE',
        fillOpacity: 0.5,
        stroke: true,
        strokeColor: '318CE7',
        strokeWidth: 2
      });

      $('#catmouth_img').mapster({
        singleSelect: true,
        fillColor: '6CB4EE',
        fillOpacity: 0.5,
        stroke: true,
        strokeColor: '318CE7',
        strokeWidth: 2
      });
    });
  }
 

  changePetImage(){
      const curr_pet = this.petService.pet
      if(curr_pet.specie == 1){
        this.tooth_option = [{'code':'cat','desc':'Cat Teeth'},{'code':'kitten','desc':'Kitten Teeth'}]
      }
      else if(curr_pet.specie == 2){
        this.tooth_option = [{'code':'dog','desc':'Dog Teeth'},{'code':'puppy','desc':'Puppy Teeth'}]
      }


      if(curr_pet.specie == 2 && curr_pet.age >= 2){
        this.petService.pet_teeth.dog = true;
        this.petService.pet_teeth.cat = false;
        this.petService.pet_teeth.kitten = false;
        this.petService.pet_teeth.puppy = false;
      }
      else if(curr_pet.specie == 2 && curr_pet.age < 2){
        this.petService.pet_teeth.dog = false;
        this.petService.pet_teeth.cat = false;
        this.petService.pet_teeth.kitten = false;
        this.petService.pet_teeth.puppy = true;
      }
      else if(curr_pet.specie == 1 && curr_pet.age >= 3){
        this.petService.pet_teeth.dog = false;
        this.petService.pet_teeth.cat = true;
        this.petService.pet_teeth.kitten = false;
        this.petService.pet_teeth.puppy = false;
      }
      else if(curr_pet.specie == 2 && curr_pet.age < 3){
        this.petService.pet_teeth.dog = false;
        this.petService.pet_teeth.cat = false;
        this.petService.pet_teeth.kitten = true;
        this.petService.pet_teeth.puppy = false;
      } 
  }

  onselectTeethDD(){ 
    if(this.selectedTeethType == 'dog'){
        this.petService.pet_teeth.dog = true;
        this.petService.pet_teeth.cat = false;
        this.petService.pet_teeth.kitten = false;
        this.petService.pet_teeth.puppy = false;
    }
    else if(this.selectedTeethType == 'puppy'){
        this.petService.pet_teeth.dog = false;
        this.petService.pet_teeth.cat = false;
        this.petService.pet_teeth.kitten = false;
        this.petService.pet_teeth.puppy = true;
    }
    else if(this.selectedTeethType == 'cat'){
        this.petService.pet_teeth.dog = false;
        this.petService.pet_teeth.cat = true;
        this.petService.pet_teeth.kitten = false;
        this.petService.pet_teeth.puppy = false;
    }
    else if(this.selectedTeethType == 'kitten'){
        this.petService.pet_teeth.dog = false;
        this.petService.pet_teeth.cat = false;
        this.petService.pet_teeth.kitten = true;
        this.petService.pet_teeth.puppy = false;
    }
  }

  save() {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    if (this.petService.pet_dental.note_type && this.petService.pet_dental.note_type === '') this.petService.pet_dental.note_type = 'Med';
    if (this.petService.pet_dental.username && this.petService.pet_dental.username === '') this.petService.pet_dental.username = 'JFF';
    if (this.petService.pet_dental.perio && this.petService.pet_dental.perio !== '')
      this.petService.pet_dental.perio_name = this.catalogService.dental_problem.find(t => t.problem_index === Number(this.petService.pet_dental.perio)).problem_name;
    if (this.petService.pet_dental.calc && this.petService.pet_dental.calc !== '')
      this.petService.pet_dental.calc_name = this.catalogService.dental_problem.find(t => t.problem_index === Number(this.petService.pet_dental.calc)).problem_name;
    if (this.petService.pet_dental.plaque && this.petService.pet_dental.plaque !== '')
      this.petService.pet_dental.plaque_name = this.catalogService.dental_problem.find(t => t.problem_index === Number(this.petService.pet_dental.plaque)).problem_name;
    if (this.petService.pet_dental.bleed && this.petService.pet_dental.bleed !== '')
      this.petService.pet_dental.bleed_name = this.catalogService.dental_problem.find(t => t.problem_index === Number(this.petService.pet_dental.bleed)).problem_name;
    if (this.petService.pet_dental.occlusion && this.petService.pet_dental.occlusion !== '')
      this.petService.pet_dental.occlusion_name = this.catalogService.dental_problem.find(t => t.problem_index === Number(this.petService.pet_dental.occlusion)).problem_name;

    this.petService.setupPetVitals()
      .then(() => {
        this.petService.setupPetDental()
          .then(() => {
            Swal.close();

            Swal.fire({
              title: 'Information stored correctly',
              didOpen: () => {
              },
            })
          });
      });
  }

  setType($event) {
    console.log($event);
    this.petService.pet_dental.note_type = $event
  }

  handleMapClick(txt_teethname: string) {
    console.log(txt_teethname)
  }

  filterCatalog(start: number, end: number): DentalProblemModel[] {
    return this.catalogService.dental_problem.filter(t => t.problem_index >= start && t.problem_index <= end);
  }

  filterProcs(): CodesFileModel[] {
    return this.catalogService.codes_file.filter(t => t.code_category === 'DENTL');
  }

  problem($event) {
    this.first_index = Number($event.target.value) === 0 ? 0 : Number(`${Number($event.target.value)}01`);
    this.last_index = Number($event.target.value) === 0 ? 0 : Number(`${Number($event.target.value)}99`);
  }

  add() {
    let category_name = this.catalogService.dental_problem.find(t => t.problem_index === Number(this.petService.pet_tooth.category_index)).problem_name;
    let problem_name = this.catalogService.dental_problem.find(t => t.problem_index === Number(this.petService.pet_tooth.problem_index)).problem_name;
    //let code_name = this.catalogService.dental_code.find(t => Number(t.code_no) === Number(this.petService.pet_tooth.code_no)).code_name;
    this.petService.pet_dental.tooth_problem.push(new ToothProblemModel(this.pet_no, this.petService.pet_tooth.problem_index, this.petService.pet_tooth.tooth_no, this.petService.pet_tooth.category_index, category_name.trim(), problem_name.trim(), this.petService.pet_tooth.code_no, ''));
    this.petService.pet_tooth = new ToothProblemModel(0, '', '', '', '', '', '', '');
  }

  delete(i: number) {
    this.petService.pet_dental.tooth_problem.splice(i, 1);
  }
  
  areaOnclick(selectedTeethArea:number){
    this.selectedTooth = selectedTeethArea;
    this.petService.pet_tooth.tooth_no = String(selectedTeethArea); 
  }

  onSelectedTeethArea(){
    console.log(this.petService.pet_tooth.tooth_no); 
    $('#t' + this.petService.pet_tooth.tooth_no).mapster('set', true);
  }


  //#region New Tooth Click Event    
  handlePathClickValue(value: number) { 
    //alert('Number from path clicked in parent:'+  value); 
  }

  toothClicked(toothId: number) { 
    this.selectedToothId = toothId; 
    this.petService.pet_tooth.tooth_no = String(toothId);  
  }  

  isToothSelected(toothId: number): boolean {
    return this.selectedToothId === toothId;
  } 

  isToothInProblem(toothId: number): boolean {
    return this.petService.pet_dental.tooth_problem.some(
      (problem) => Number(problem.tooth_no) === toothId
    );
  }
  //#endregion

  //#region from EXAM NOTE PAGE
  exam_note: string = '';
  exam_note_type: string = '';
  
    saveExamNote(){
      let notetype_array = []
      let txtnote =   this.exam_note + ' -- ' + this.petService.userData.employee_name;
      if(this.exam_note_type != '' && this.exam_note != '') {  
        if(this.exam_note_type == 'Med'){
          notetype_array.push(2);
        }
        else if(this.exam_note_type == 'Disch'){
          notetype_array.push(7);
        }
        else if(this.exam_note_type == 'Recp'){
          notetype_array.push(8);
        }
        else if(this.exam_note_type == 'Hosp'){
          notetype_array.push(1);
        } 
      }
      else{
        Swal.fire({ 
          title: 'Note Type and Content is Required'
        });
  
        return false
      }
  
  
      this.petService.note = new NoteModel(0, this.pet_no,  '','', txtnote, notetype_array); 
      this.petService.setupNote().then(()=>{
          Swal.fire({title: 'Saved Successfully'})
          this.petService.note = new NoteModel(0,0, '','','',[])
      })
    }
  
    //#endregion

}
